import HtmlParser from 'html-react-parser';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';
import Helmet from 'react-helmet';
import ReactPlayer from 'react-player';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import { DemoFormShort } from '../../components/DemoFormShort.jsx';
import JoinHappyCustomers from '../../components/JoinHappyCustomers';
import MultimedialPanel from '../../components/MultimedialPanel';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';


function HeroModal() {
	const [modalShow, setModalShow] = React.useState(false);

	const handleModalClose = () => setModalShow(false);
	const handleModalShow = () => setModalShow(true);

	return (
		<div className="d-flex mt-1 mb-1">
			<Button variant="" onClick={handleModalShow} className="cta cta-video">See it in action</Button>

			<Modal show={modalShow} onHide={handleModalClose} centered>
				<Modal.Header closeButton></Modal.Header>
				<Modal.Body>
					<ResponsiveEmbed aspectRatio="16by9">
						<ReactPlayer
							url='https://www.youtube.com/watch?v=imlCTIiMTok'
							playing
							volume={1}
							controls={true}
							width='100%'
							height='100%'
						/>
					</ResponsiveEmbed>

				</Modal.Body>
			</Modal>
		</div>
	);
}

const Home = (props) => {

    const location = props.location;

    return (
        <Layout  bodyClass="page-integrations-planning" ontouchstart>
            <SEO title="Headcount Planning | ChartHop | People Analytics, Visualized" />
            <Helmet>
                <meta
                    name="description"
                    content="Use scenarios to design headcount plans and measure the impact structural and budgetary impact of your changes. Finally - fast, easy, and flexible org design."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Headcount Planning | ChartHop | People Analytics, Visualized" />
                <meta property="og:description" content="Use scenarios to design headcount plans and measure the impact structural and budgetary impact of your changes. Finally - fast, easy, and flexible org design." />
                <meta property="og:image" content={`https://www.charthop.com/home/meta-planning.png`} />
                <meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Headcount Planning | ChartHop | People Analytics, Visualized" />
                <meta name="twitter:description" content="Use scenarios to design headcount plans and measure the impact structural and budgetary impact of your changes. Finally - fast, easy, and flexible org design." />
                <meta name="twitter:image" content={`https://www.charthop.com/home/meta-planning.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>

            {/* HERO CONTENT */}
            <section className="intro container">
                <div className="row py-5 align-items-center">
                    <div className="col-md-6 p-xs-2 mb-3 mb-md-0 pr-md-2 pr-lg-4">
                        <h1>Headcount planning without the headache </h1>
                        <p className="header-p pb-1 pt-1">Easily align on headcount plans to help your organization scale.</p>
                        <div className="splitText"><DemoFormShort source={"platform-planning-demo-header"} /></div>   
						<HeroModal />                     
                    </div>
					<div className="reactPlayerContainer col-md-6 order-md-1 padding-top-video-one">                        
                        <ReactPlayer
                            url="/platform/planning/headcount-planning-hero.mp4"
                            playing
                            loop
                            muted
                            playsinline
                        />

					</div>
                </div>
            </section>

	

			{/* never */}
            <section className="sectionSpacing flex-centeredColumn">
            	<h2 className="text-center mt-0 sectionSpacing-Margin">Model, forecast, and execute headcount plans</h2> 
            	<div className="flex-centeredColumn contentBlock">
					<div className="svg-info ">
                    <div className="svg-info-card-3col">
                    		
                    		<img src={'/product/org-chart/agility.svg '} alt="Data Access" />
							<h3>Streamline workflows</h3>
							<p>Distribute and consolidate plans without countless spreadsheets</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/product/org-chart/visualize.svg'} alt="Put a face to the name" />
							<h3>Visually create plans</h3>
							<p>Create headcount plans using an org chart to easily visualize your entire org or team</p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/covid-data/icon-analytics.svg'} alt="Work" />
							<h3>Design your org with data</h3>
							<p>Use data such as performance, engagement, compensation, demographics, and more to drive planning</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/product/org-chart/money.svg'} alt="Time Saving" />
							<h3>Forecast costs</h3>
							<p>Estimate headcount costs, including salary, bonus, and equity, for different scenarios </p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/product/org-chart/transparency.svg'} alt="Transparency" />
							<h3>Turn plans into action</h3>
							<p>Create job requisitions from your headcount plan and launch them directly to your ATS</p>
						</div>                       
                        <div className="svg-info-card-3col">
							<img src={'/product/org-chart/productivity.svg'} alt="Visualize" />
							<h3>Empower all stakeholders</h3>
							<p>Collaborate on headcount plans with managers, the finance team, and executives</p>
						</div>
					</div>
				</div>
            </section>

			{/* team */}
			<section className="sectionSpacing backgroundGradientContainer">
				<div className="contentBlock">
					<MultimedialPanel 
                        multimediaPosition="right"
                        title="Streamline the planning process as your org scales"
                        link="/product/2105-refresh/performance-expectations.png"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Focus on the actual headcount plan instead of spending time distributing and consolidating hiring plan spreadsheets.</p>
                                <p>And when the final plan is approved, you can send new requisitions directly to your ATS via  bi-directional integration.</p>
                            </React.Fragment>
                        }
                    />					
				</div>
			</section>

			{/* Collaborate */}
			<section className="sectionSpacing">
				<div className="contentBlock">
					<MultimedialPanel 
                        multimediaPosition="left"
                        title="Collaborate on headcount plans with finance, senior leaders, and managers"
                        link="/product/2105-refresh/scenarios-sharing.png"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Empower managers with the ability to create their own headcount plans for their team. With access-controlled data, managers can create plans for promotions, turnover, and succession. Once managers are happy with their plans, your people team can easily consolidate plans and share a final output with executives for approval.</p>                            
                            </React.Fragment>
                        }
                    />	
				</div>
			</section>

			{/* impact */}            
            <section className="sectionSpacing backgroundGradientContainer">
				<div className="contentBlock">
					<MultimedialPanel 
                        multimediaPosition="right"
                        title="Design your organization based on data-driven insights"
                        link="/product/2105-refresh/data-driven.png"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Power headcount plans with data such as employee performance, compensation, demographic data, and span of control. Visualize these insights on your org chart so you can make data-driven decisions for your headcount plans.</p>
                                <p>Make it easy to create headcount plans with a visual display of the organization, including people, open roles, departments, and teams.</p>
                            </React.Fragment>
                        }
                    />						
				</div>
			</section>

			{/* Collaborate */}
			<section className="sectionSpacing">
				<div className="contentBlock">
					<MultimedialPanel 
                        multimediaPosition="left"
                        title="Forecast the impact of your proposed headcount plans"
                        link="/platform/planning/forecast-impact.png"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Unlock built-in forecasting tools so your finance team can easily compare the cost and impact of proposed headcount plans against the current baseline. View the impact of compensation changes or new headcount by department, location, job type, and more.</p>                            
                            </React.Fragment>
                        }
                    />	
				</div>
			</section>

			<div className="sectionSpacing-Margin mx-0 mt-0">
				<h4 className="listTitle mt-0 text-center pt-3">The complete solution for employee engagement.</h4>
				<div className="flex-centeredColumn contentBlock text-center">
				<div className="pgc1 display-block-pgc1" style={{maxWidth:"1000px"}}>
					<div className="pgc2-2">
						<div className="pgc3">
							<img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
							<p>Headcount Planning</p>
						</div>
					</div>
					<div className="pgc2-2">
						<div className="pgc3">
							<img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
							<p>Headcount Forecasting</p>
						</div>	
					</div>
					<div className="pgc2-2">
						<div className="pgc3">
							<img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
							<p>M&A Integrations</p>
						</div>
					</div>
					<div className="pgc2-2">
						<div className="pgc3">
							<img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
							<p>Org Restructuring</p>
						</div>
					</div>
					<div className="pgc2-2">
						<div className="pgc3">
							<img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
							<p>Promotion and Turnover Plans</p>
						</div>
					</div>
					<div className="pgc2-2">
						<div className="pgc3">
							<img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
							<p>Continuous Adjustments</p>
						</div>
					</div>
				</div>
				</div>
				<p class="subListTitle mb-0 font-weight-bold text-center">&amp; more</p>
			</div>

            {/* LONG FORM */}
            <section name="request-demo " id="request-demo" className="request-demo request-demo-white pt-3 pb-4 pt-md-8 pb-md-8">
				<DemoFormLong source={"platform-planning-demo-bottom"} centerContent={true} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">“ChartHop helped us centralize over a hundred headcount planning spreadsheets into a single platform.</br></br> We could easily monitor people’s access, progress and consolidate multiple plans with a couple of clicks.”</p><div class="authorTag"><img src="/home/quotes/quote_AlexKoykova@2x.jpg" class="testimonialAuthor" alt="Alex Koykova" /><div><p class="contactAuthor"><strong>Alex Koykova</strong> <br>Director, People Operations<br><img src="/home/brand_logos/mongodb-logo-original.svg" alt="MongoDB" class="MongoDBauthor" /></p></div></div>')}/>
			</section>
        </Layout>
    );
};


export default Home;
